import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_regular_maintenance_inspection_testing_emergency_alarm_system'

export const dataPointDefinition = {
  retracedId: 'no_regular_maintenance_inspection_testing_emergency_alarm_system',
  name: 'No regular maintenance, inspection and/or testing of emergency alarm system',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-eme-14x',
      number: 'HS-EME-7-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-eme-12',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-eme-2;hs-eme-8,Yes',
      machineShowHide: '[2],hs-eme-2;hs-eme-8,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-14x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30610,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
